import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Icon = _resolveComponent("Icon");
    const _component_Tooltip = _resolveComponent("Tooltip");
    return (_openBlock(), _createBlock(_component_Tooltip, {
        tip: _ctx.title,
        placement: _ctx.tipPlacement
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", {
                style: _normalizeStyle(_ctx.flexFixedWidth + (_ctx.clickable ? 'cursor: pointer;' : '')),
                class: "title-element"
            }, [
                (_ctx.useFirst)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_Icon, { icon: _ctx.iconID1 }, null, 8, ["icon"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_Icon, {
                            icon: _ctx.iconID2,
                            style: _normalizeStyle(_ctx.icon2Style)
                        }, null, 8, ["icon", "style"])
                    ]))
            ], 4)
        ]),
        _: 1
    }, 8, ["tip", "placement"]));
}
